import { render, staticRenderFns } from "./SocialSideBar.vue?vue&type=template&id=c8b9d798&scoped=true&"
import script from "./SocialSideBar.vue?vue&type=script&lang=js&"
export * from "./SocialSideBar.vue?vue&type=script&lang=js&"
import style0 from "./SocialSideBar.vue?vue&type=style&index=0&id=c8b9d798&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b9d798",
  null
  
)

export default component.exports